import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('errorBoundary');

    return {
        MAP_ERROR_MESSAGE: t('mapErrorMessage'),
        MAP_FAILED_TO_LOAD: t('mapFailedToLoad'),
        RELOAD_BUTTON: t('reloadButton')
    };
};

export default useTranslation;
